import { apiSlice } from "../../apiSlice"

export const activationsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Activations'],
    endpoints: builder => ({
        getActivations: builder.query({
            query: (args) => {
                const { from, to, gatewayId } = args
                return {
                    url: `/ActivationStatus?orderby=Timestamp&Timestamp=gt(${from})&Timestamp=le(${to})&GatewayId=eq(${gatewayId})&top=10000`
                }
            },
            providesTags: ['Activations'],
            keepUnusedDataFor: 60, //This is the caching mechanism keeps the data for 5 seconds - default is 60
        })
    })
})

export const {
    useGetActivationsQuery,
    useLazyGetActivationsQuery,
} = activationsApiSlice